export default "__VITE_ASSET__CvhBsW$k__"